export default __webpack_public_path__ + "static/media/checked_no_outline.f3aa1bc8.svg";